import { connect } from "react-redux";
import { Actions as ADVENTCALENDARACTIONS } from "../../store/actions/adventCalendarActions";
import { Fragment, useEffect, useState } from "react";


import LoginForm from "../login/LoginForm";
import BasicRegistrationForm from "../common/BasicRegistrationForm";
function LoginRegister({ signInModal, loggedIn, headerText }) {

    const [mobileView, setMobileView] = useState('login')
    const isMobile = document.documentElement.clientWidth < 800

	return (
		<div>
            <div className="flex justify-center font-advent text-7xl mb-5 drop-shadow-lg">
                { (!isMobile || mobileView == 'login') ?
                    headerText ?? "Sign in"
                    : "Sign up"
                }
            </div>
            <div className={`flex items-center ${isMobile ? `mb-0` : `mb-12`} drop-shadow-lg`}>
                { (!isMobile || mobileView == 'login') &&
                    <LoginForm
                        joinOrder={isMobile ? 'none' : 0}
                        formFooter={isMobile && <div onClick={() => setMobileView('register')} className="text-center justify-center text-xs mt-5 mb-5 text-gray-500 cursor-pointer">No Account?<br/> <u>Click here</u> to create one now.</div>}/>
                }
                { (!isMobile || mobileView == 'register') &&
                    <BasicRegistrationForm
                        joinOrder={isMobile ? 'none' : 1}
                        hideFooter={true}
                        formFooter={isMobile && <div onClick={() => setMobileView('login')} className="text-center justify-center text-xs mt-0 mb-5 text-gray-500 cursor-pointer">Already have an account?<br/> <u>Click here</u> to login.</div>}
                    />
                }
            </div>
        </div>
	);
}

const mapStateToProps = (state) => {
	return {
		signInModal: state.adventCalendar.signInModal || false,
		loggedIn: !!state.my.profile?.email,
	};
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginRegister);





